module.exports = __webpack_public_path__ + "media/images/logo-green-mountain-d0f4174daed7a61e63a233cac71f8392.png";